import { TListResponse } from 'src/common/types';
import { TTableSort, TTableSortCols } from 'src/components/table/thead/col';

import { TUserMeta, TUserMetaResponse, adaptUserMetaFromResponse, adaptUserMetaUndefinedFromResponse } from './user-meta.type';
import { adaptProviderSourceFromResponse, TProviderSource, TProviderSourceResponse } from './provider-source.type';


export const ProviderUserListSortCol = {
	NAME: 'name',
	UPDATED_AT: 'updated_at',
	CREATED_AT: 'created_at',
};

export type TProviderUserListSortCol = TTableSortCols<typeof ProviderUserListSortCol>;

export type TProviderUserListQuery = {
	limit: number;
	offset: number;
	search?: string;
	sort?: TTableSort;
	sortCol?: TProviderUserListSortCol;
};

export type TProviderUserListQueryRequest = {
	limit?: number;
	offset?: number;
	search?: string;
	sort?: string;
	sort_col?: string;
};

export function adaptProviderUserListQueryToRequest(data?: TProviderUserListQuery): TProviderUserListQueryRequest {
	if (!data) {
		return {};
	}

	const {
		sortCol,
		...restFields
	} = data;

	return {
		sort_col: sortCol,
		...restFields
	};
}

export type TProviderUser = {
  id: number;
  clientId?: string;
  secretKey?: string;
	isActive: boolean;
	createdAt: string;
  updatedAt: string;

  provider: TProviderSource;
  user: TUserMeta;
	createdBy?: TUserMeta;
	updatedBy?: TUserMeta;
};

export type TProviderUserResponse = {
  id: number;
  client_id?: string;
  secret_key?: string;
	is_active: boolean;
  created_at: string;
  updated_at: string;

  provider: TProviderSourceResponse;
  user: TUserMetaResponse;
	created_by?: TUserMetaResponse;
	updated_by?: TUserMetaResponse;
};

export type TProviderUserListResponse = TListResponse<TProviderUserResponse>;

export type TProviderUserList = TListResponse<TProviderUser>;

export type TProviderUserPayloadRequest = {
	userNickname: string;
	providerId: number;
	clientId?: string;
	secretKey: string;
	isActive: boolean;
};

export type TProviderUserRequest = {
	user_nickname: string;
	provider_id: number;
	client_id?: string;
	secret_key: string;
	is_active: boolean;
};

export type TProviderUserPayloadUpdate = {
	id: number;
	data: TProviderUserPayloadRequest;
};

export function adaptProviderUserFromListResponse(data: TProviderUserListResponse): TProviderUserList {
	const {
		items: itemsRaw = [],
		...restFields
	} = data;

	const items = itemsRaw.map(item => adaptProviderUserFromResponse(item));

	return {
		items,
		...restFields
	};
}

export function adaptProviderUserFromResponse(data: TProviderUserResponse): TProviderUser {
	const {
		id,
		client_id: clientId,
		secret_key: secretKey,
		is_active: isActive,
		provider: providerRaw,
		user: userRaw,
		created_at: createdAt,
		updated_at: updatedAt,
		created_by: createdByRaw,
		updated_by: updatedByRaw,
	} = data;

	const provider = adaptProviderSourceFromResponse(providerRaw);
	const user = adaptUserMetaFromResponse(userRaw);
	const createdBy = adaptUserMetaUndefinedFromResponse(createdByRaw);
	const updatedBy = adaptUserMetaUndefinedFromResponse(updatedByRaw);

	return {
		id,
		clientId,
		secretKey,
		isActive,
		provider,
		user,
		createdAt,
		updatedAt,
		createdBy,
		updatedBy,
	};
}

export function adaptProviderUserToRequest(data: TProviderUserPayloadRequest): TProviderUserRequest {
	const {
		userNickname,
		providerId,
		clientId = undefined,
		secretKey,
		isActive,
	} = data;

	return {
		user_nickname: userNickname,
		provider_id: providerId,
		client_id: clientId,
		secret_key: secretKey,
		is_active: isActive,
	};
}
